import {flow, get, head} from '@yandex-delivery/utils'

import type {CardListResponse} from '../../../repo/cargo-corp/types'

export const toBoundedPaymentCard: (r: CardListResponse) => string | undefined = flow(
  get('bound_cards'),
  head,
  get('card_id'),
)
